import React, { useState } from "react";
import { motion } from "framer-motion";
import emailjs from '@emailjs/browser';

export default function ContentWithForm() {
  const [showForm, setShowForm] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [error, setError] = useState("");

  const toggleForm = () => {
    setShowForm(!showForm);
    setFormSubmitted(false);
    setError("");
  };


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.name ||  !formData.phone || !formData.email || !formData.message) {
      setError("All fields are required.");
      return;
    }
  
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError("Please enter a valid email address.");
      return;
    }
  
    setFormSubmitted(true);
    setError("");
  
    const templateParams = {
      from_name: formData.name,
      phone: formData.phone,
      from_email: formData.email,
      service: formData.service,
      message: formData.message,
    };
  
    try {
      const result = await emailjs.send(
        'service_36wo8bt',     // e.g. 'service_xxxxxx'
        'template_86y0k7l',    // e.g. 'template_abcd123'
        templateParams,
        'AIO6wYVOOFNn0o1uT'      // e.g. 'abc123DEF456ghi789'
      );
  
      console.log('Email sent successfully:', result.text);

  
      setTimeout(() => {
        setShowForm(false);
      }, 2000);
    } catch (error) {
      console.error('Email sending error:', error);
      setError("There was an error submitting your enquiry.");
      setFormSubmitted(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === "overlay") {
      setShowForm(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.columnContainer}>
        <div style={styles.leftColumn}>
          <h1>
            Based in Hosur and Designing Across the State, Samson and
            Associates Shapes Spaces Through Architecture, Interiors, and
            Engineering.
          </h1>
        </div>
        <div style={styles.rightColumn}>
          <p style={styles.text}>
          Let’s Shape Your Vision Together! Contact us today.
          </p>
          
          <motion.button
                  style={styles.motionButton}
                  variants={{
                    initial: { color: "black" },
                    hover: { color: "white" },
                  }}
                  initial="initial"
                  whileHover="hover"
                  onClick={toggleForm}
                >
                  <motion.span
                    style={styles.motionButtonBackground}
                    variants={{
                      initial: { x: "-100%" },
                      hover: { x: 0, transition: { duration: 0.4 } },
                    }}
                  />
                  <span style={{ position: "relative", zIndex: 1, }}>Make an Enquiry</span>
                </motion.button>
        </div>
      </div>

      {showForm && (
        <div style={styles.overlay} className="overlay" onClick={handleOverlayClick}>
          <div style={styles.formContainer}>
            {formSubmitted ? (
              <h2 style={styles.successMessage}>
                Thank you! Your inquiry has been submitted.
              </h2>
            ) : (
              <>
                <h2 style={styles.formTitle}>Quick Inquiry</h2>
                {error && <p style={styles.error}>{error}</p>}
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  style={styles.input}
                  onChange={handleChange}
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone Number"
                  style={styles.input}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  style={styles.input}
                  onChange={handleChange}
                />
                <select name="service" style={styles.input} onChange={handleChange}>
                  <option value="">Select a Service</option>
                  <option value="Architecture">Architecture</option>
                  <option value="Interiors">Interiors</option>
                  <option value="Engineering">Engineering</option>
                </select>
                <textarea
                  name="message"
                  placeholder="Your Message"
                  style={styles.textarea}
                  onChange={handleChange}
                ></textarea>
                
                <motion.button
                  style={styles.motionButton}
                  variants={{
                    initial: { color: "grey" },
                    hover: { color: "white" },
                  }}
                  initial="initial"
                  whileHover="hover"
                  onClick={handleSubmit}
                >
                  <motion.span
                    style={styles.motionButtonBackground}
                    variants={{
                      initial: { x: "-100%" },
                      hover: { x: 0, transition: { duration: 0.4 } },
                    }}
                  />
                  <span style={{ position: "relative", zIndex: 1 }}>Submit</span>
                </motion.button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    height: "auto",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    marginTop: "20px",                                                                                              
    backgroundColor: "#fff5f2",
  },
  columnContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: "auto",
  },
  leftColumn: {
    flex: 1,
    fontSize: "18px",
    textAlign: "left",
    padding: "10px",
    minWidth: "300px",
  },
  rightColumn: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    minWidth: "300px",
  },
  text: {
    fontSize: "16px",
    textAlign: "center",
    marginBottom: "20px",
  },
  button: {
    padding: "12px 24px",
    fontSize: "16px",
    backgroundColor: "#5c0e14",
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "8px",
    transition: "0.3s",
    boxShadow: "3px 3px 15px rgba(0, 0, 0, 0.3)",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  formContainer: {
    background: "#fff8f1",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.4)",
    textAlign: "center",
    width: "90%",
    maxWidth: "400px",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    border: "none",
    borderBottom: "2px solid grey",
    fontSize: "14px",
    outline: "none",
  },
  textarea: {
    width: "100%",
    height: "80px",
    padding: "10px",
    margin: "10px 0",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px",
    resize: "none",
  },
  motionButton: {
    position: "relative",
    height: "50px",
    overflow: "hidden",
    padding: "12px 24px",
    fontSize: "18px",
    fontWeight: "bold",
    background: "transparent",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    border: "none",
  },
  motionButtonBackground: {
    position: "absolute",
    inset: 6,
    borderRadius: "5px",
    background: "#5c0e14",
  },
  successMessage: {
    fontSize: "18px",
    color: "green",
    textAlign: "center",
  },
  formTitle: {
color:"#5c0e14"
  },
};
